import { apiSlice } from '../api/apiSlice';

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => ({ url: '/tasks' }),
      providesTags: ['Status'],
    }),
    getTask: builder.query({
      query: (id) => ({ url: `/tasks/${id}` }),
      providesTags: ['SingleTask'],
    }),
    changeStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Status'],
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: `/tasks`,
        method: 'POST',
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          if (result?.data.id) {
            // pessimistic cache update
            dispatch(
              apiSlice.util.updateQueryData('getTasks', undefined, (draft) => {
                draft.push(result.data);
              })
            );
          }
        } catch (error) {}
      },
    }),
    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['SingleTask'],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;

          if (result?.data.id) {
            // pessimistic cache update
            dispatch(
              apiSlice.util.updateQueryData('getTasks', undefined, (draft) => {
                const indexToUpdate = draft.findIndex(
                  (task) => task.id === Number(arg.id)
                );

                draft[indexToUpdate] = result.data;
              })
            );
          }
        } catch (error) {}
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        //optimistic chche update
        const patchResult = dispatch(
          apiSlice.util.updateQueryData('getTasks', undefined, (draft) => {
            const indexToDelete = draft.findIndex((task) => task.id === arg);
            draft.splice(indexToDelete, 1);
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useChangeStatusMutation,
  useDeleteTaskMutation,
  useAddTaskMutation,
  useGetTaskQuery,
  useEditTaskMutation,
} = tasksApi;
